import { Resource } from '../constants/resources';

export const useResourceAction = () => {
  const handleResourceAction = (
    resource: Resource,
    onPaymentClick?: () => void,
    onDownloadComplete?: () => void
  ) => {
    // Si es un recurso gratuito/descargable, descargar directamente
    if (resource.buttonText === 'Descargar' || resource.price === 'Gratis') {
      // Crear un elemento <a> temporal para forzar la descarga
      const link = document.createElement('a');
      link.href = resource.link;
      link.download = resource.link.split('/').pop() || 'recurso.pdf';
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      // Callback opcional después de iniciar descarga
      if (onDownloadComplete) {
        onDownloadComplete();
      }
    } else if (onPaymentClick) {
      // Si es de pago, ejecutar callback para mostrar info de pago
      onPaymentClick();
    }
  };

  return { handleResourceAction };
};
